module.exports = __webpack_public_path__ + "img/xxshcy.06b303c2.svg";